import { useQuery } from 'react-query';
import { IPaginationParams } from '../../../types';
import { ISchoolBoardFilterParams } from '../../types';
import {
  getAllSchoolBoardsByLicenseAsync,
  getAllSchoolBoardsByLicenseCountAsync,
  getSchoolBoardByIdAsync,
} from '../../index';
import { getUserId } from '../../../DefaultService';

const USER_ID = getUserId();

export const useGetAllSchoolBoardsByLicenseAsync = (
  pagination: IPaginationParams,
  filter: ISchoolBoardFilterParams,
) =>
  useQuery([`schoolBoards${pagination.pageNumber}`, pagination, USER_ID, filter], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllSchoolBoardsByLicenseAsync(pagination, filter),
  });

export const useGetAllSchoolBoardsByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: ISchoolBoardFilterParams,
) =>
  useQuery([`schoolBoardsCount${pagination.pageNumber}`, pagination, USER_ID, filter], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllSchoolBoardsByLicenseCountAsync(filter),
  });


export const useGetSchoolBoardByIdAsync = (id: number, enabled: boolean = true) =>
  useQuery([`schoolBoardDetail`, id, USER_ID], {
    queryFn: () => getSchoolBoardByIdAsync(id),
    enabled: enabled && !!id,
  });